<template>
  <div class="chart-filter-customgoal-select">
    <div v-if="!persistLabel" class="chart-filter-label">
      {{ capitalize(goalsTitle) }} Interaction:
    </div>
    <v-select
      v-if="customGoalInteractionItems.length > 1"
      v-model="experimentsStore.customGoalInteraction"
      hideDetails
      density="compact"
      variant="outlined"
      :items="customGoalInteractionItems"
      itemTitle="text"
      height="32"
      style="max-width: 200px; width: 200px"
      :label="persistLabel ? `${goalsTitle} Interaction` : null"
      :menuProps="{ offsetY: true }"
    />
  </div>
</template>

<script>
import { useExperimentsStore } from "@/pinia/experimentsStore";
import { useCustomFields } from "@/utils/composables/useCustomFields";
import CustomGoalInteractionMixin from "@/utils/CustomGoalInteractionMixin";
import StringUtils from "@/utils/StringUtils";
import {
  isAccept2Enabled,
  isDeclineEnabled,
  isDismissEnabled,
} from "@/utils/prompts/promptHelpers";

export default {
  name: "RfCustomGoalInteractionSelector",
  mixins: [CustomGoalInteractionMixin],
  props: ["model", "persistLabel"],
  setup: () => {
    // why? because we need to use onMounted from useCustomFields and Mixins do not support composition API
    // and we need to use appCustomFields in CustomGoalInteractionMixin
    const { appCustomFields } = useCustomFields();
    return {
      appCustomFields,
      capitalize: StringUtils.capitalize,
      experimentsStore: useExperimentsStore(),
    };
  },
  computed: {
    actions() {
      return this.model.actions || {};
    },
    customGoalInteractionItems() {
      const items = [];

      if (this.model.path_type !== "invisible") {
        items.push({ value: "seen", text: this.interactionText.seen });
      }

      items.push({ value: "accepted", text: this.interactionText.accepted });

      if (isAccept2Enabled(this.model)) {
        items.push({ value: "accepted2", text: this.interactionText.accepted2 });
      }
      if (isDeclineEnabled(this.model)) {
        items.push({ value: "declined", text: this.interactionText.declined });
      }
      if (isDismissEnabled(this.model)) {
        items.push({ value: "dismissed", text: this.interactionText.dismissed });
      }
      return items;
    },
  },
  mounted() {
    this.experimentsStore.customGoalInteraction = this.customGoalInteractionValue();
  },
  unmounted() {
    this.experimentsStore.customGoalInteraction = "accepted";
  },
  methods: {
    customGoalInteractionValue() {
      if (this.model.path_type === "invisible") return "accepted";
      return "seen";
    },
  },
};
</script>

<style scoped>
.chart-filter-customgoal-select {
  display: flex;
  align-items: center;
}
.chart-filter-label {
  padding-right: 10px;
}
</style>
